import { Exception } from '../../../../errors/exception'
import { HttpStatusCode } from '../../../../errors/http-status-code'
import type { IAuth } from '../../domain/use-cases/i-auth'
import type { IAuthClient } from '../data-sources/i-auth-client'

export class AuthRepository implements IAuth {
  constructor(
    readonly dataSource: IAuthClient,
    readonly key: string,
  ) {}

  async getToken(): Promise<string> {
    const result = await this.dataSource.getToken(this.key)

    if (result.status !== HttpStatusCode.NO_CONTENT) {
      throw new Exception(result.status, result.message!)
    }

    return result.data
  }
}
